export default "__VITE_ASSET__BkcdEOf8__"